import { reportUiFailure, shouldReport } from "../../report-failure.js";

// A served notification row with no text is reported at most once per agent in this window.
export const NOTICE_WITHOUT_TEXT_REPORT_MS = 60 * 60_000;

export function reportNoticeWithoutText(agentId: string, seq: number | undefined): void {
  if (!shouldReport(`agents.notice_without_text:${agentId}`, NOTICE_WITHOUT_TEXT_REPORT_MS)) return;
  reportUiFailure("agents.notice_without_text", new Error("notification row has no text"), {
    agentId,
    seq,
  });
}
